module.exports = __webpack_public_path__ + "img/virtual_account_active.784d9867.svg";